export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/e8d31bd09f125f4695d7b9b3c697f26f/2be16e83cad66270ef27abaacfa9c9bc.png" 
                  alt="NAKAYAMA CAPITAL Logo" 
                  className="w-8 h-8 object-contain filter invert"
                />
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                中山キャピタル株式会社
              </h3>
            </div>
            <p className="text-gray-300 mb-4">
              仕組みで、未来をデザインする。
            </p>
            <p className="text-gray-400 text-sm">
              資産を生み出す仕組みの設計と構築を行う企業として、個人・法人の長期的な発展を支援します。
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">事業内容</h4>
            <ul className="space-y-2 text-gray-300">
              <li>経営コンサルティング事業</li>
              <li>教育・スクール事業</li>
              <li>物流・貿易サポート事業</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 中山キャピタル株式会社. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors ml-1 cursor-pointer">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}